import React, { Suspense } from 'react'
import lazy from './LazyWithRetry'
import { Route, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux'
import RoutesConfig from './RoutesConfig'
import { intersection } from 'lodash'
import PntAlertProvider from '../../containers/pages/alert/PntAlertContext'
import AppCacheAndLogout from '../../components/utils/AppCacheAndLogout'
import TableQueryProvider from '../../components/app-context/TableQueryContext'
import HeaderSelector from '@/components/header/HeaderSelector'
import GlobalLoader from '../../components/loading/GlobalLoader'

const PageNotFound = lazy(() => import('../../components/errors/PageNotFound'))
const CtmProjectActionPage = lazy(() => import('../../containers/pages/actions/customer/project/CtmProjectActionPage'))
const CtmOpportunityActionPage = lazy(
  () => import('../../containers/pages/actions/customer/opportunity/CtmOpportunityActionPage'),
)
const EntProjectActionPage = lazy(() => import('../../containers/pages/actions/enterprise/EntProjectActionPage'))
const GenericSuccess = lazy(() => import('@/components/success/GenericSuccess'))

const Loged = ({ standard = true }) => {
  const roles = useSelector(({ login }) => login.roles)
  const isArrayWithLength = (arr) => Array.isArray(arr) && arr.length

  return (
    <AppCacheAndLogout roles={roles}>
      <PntAlertProvider>
        <TableQueryProvider>
          <Suspense fallback={<GlobalLoader forceOpen={true} />}>
            <Routes>
              <Route element={<HeaderSelector standard={standard} />}>
                {RoutesConfig.filter(
                  ({ permission }) =>
                    !permission || !isArrayWithLength(permission) || intersection(permission, roles).length,
                ).map(({ path, title, component: Component }) => {
                  const paths = Array.isArray(path) ? path : [path]
                  return paths.map((routePath) => (
                    <Route key={title} path={routePath} element={Component ? <Component /> : <></>} />
                  ))
                })}
                <Route path="/oa/:code" element={<CtmOpportunityActionPage />} />
                <Route path="/ca/:code" element={<CtmProjectActionPage />} />
                <Route path="/entactions/:code" element={<EntProjectActionPage />} />
                <Route path="/success" element={<GenericSuccess />} />
              </Route>
              <Route path="/*" element={<PageNotFound />} />
            </Routes>
          </Suspense>
        </TableQueryProvider>
      </PntAlertProvider>
    </AppCacheAndLogout>
  )
}

export default Loged
